import type { ExtendedUserInfo } from "@services/auth/authentication";
import { PermissionsApp } from "@services/auth/authorization/authorization-service-impl";
import { useAuthentication } from "@services/auth";
import { usePermissionCheckers as useSharedPermissionCheckers } from "@services/auth/authorization/permission-checkers";

export function usePermissionCheckers(userInfo?: ExtendedUserInfo) {
    const auth = useAuthentication();
    const sharedPermissionCheckers = useSharedPermissionCheckers(userInfo);

    const getUserInfo = (): ExtendedUserInfo => {
        return userInfo || (auth.userInfo as ExtendedUserInfo);
    };

    const hasPermission = (permission: string): boolean => {
        const info = getUserInfo();
        return info.permissions?.has(permission) || false;
    };

    const canAccessOperacionesEnergia = sharedPermissionCheckers.canAccessOperacionesEnergia;

    const canAccessBorradoresOperacion = () =>
        hasPermission(PermissionsApp.ViewBorradoresBoSection);

    const canAccessFacturas = () =>
        hasPermission(PermissionsApp.ViewAllFacturas) ||
        hasPermission(PermissionsApp.ViewAssociatedFacturas);

    const canAccessSoporte = () =>
        hasPermission(PermissionsApp.GetAllTickets) ||
        hasPermission(PermissionsApp.GetAssociatedTickets);

    const canAccessClientes = () =>
        hasPermission(PermissionsApp.ViewClientesBoSection);

    const canAccessUsuarios = () =>
        hasPermission(PermissionsApp.EditAllUsuarios);

    const canAccessEmpresasServicios = () =>
        hasPermission(PermissionsApp.EditEmpresaServicios);

    const canAccessEmpresasAgentes = () =>
        hasPermission(PermissionsApp.GetEmpresasAgentes);

    const canAccessDelegacionesInmobiliarias = () =>
        hasPermission(PermissionsApp.EditAllDelegacionInmobiliaria);

    const canAccessMarcosComisiones = () =>
        hasPermission(PermissionsApp.EditAllMarcoComisiones);

    const canAccessContactosLead = () =>
        hasPermission(PermissionsApp.ViewContactosLead);

    const canAccessImportacionesOperacionesEnergia = () =>
        hasPermission(PermissionsApp.ImportOperacionesEnergia);

    const canAccessComunicados = () =>
        hasPermission(PermissionsApp.EditAllComunicados);

    return {
        canAccessFacturas,
        canAccessOperacionesEnergia,
        canAccessBorradoresOperacion,
        canAccessSoporte,
        canAccessClientes,
        canAccessUsuarios,
        canAccessEmpresasServicios,
        canAccessEmpresasAgentes,
        canAccessDelegacionesInmobiliarias,
        canAccessMarcosComisiones,
        canAccessContactosLead,
        canAccessImportacionesOperacionesEnergia,
        canAccessComunicados
    };
}